import React from 'react';
import { formatArs } from '../../utils/documentFichaMapper';

export default function ItemsSection({ items = [] }) {
  if (!items.length) return null;

  return (
    <details className="dv-section dv-section--collapsible">
      <summary className="dv-section-title">
        📋 Ítems <span className="dv-section-count">({items.length})</span>
      </summary>
      <div className="dv-section-body dv-items-body">
        <table className="dv-items-table">
          <thead>
            <tr>
              <th>Descripción</th>
              <th>Cant.</th>
              <th>P. unit.</th>
              <th>Importe</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={item.codigo || item.nombre || index}>
                <td>{item.nombre || item.descripcion || `Ítem ${index + 1}`}</td>
                <td className="num">{item.cantidad ?? '—'}</td>
                <td className="num">
                  {item.precio_unitario != null ? formatArs(item.precio_unitario) : '—'}
                </td>
                <td className="num">
                  {item.importe != null ? formatArs(item.importe) : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </details>
  );
}
